"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var Types_1 = require("Common/AssetLibrary/ImageLibrary/Types");
var ImageLibraryDataStore_1 = require("Common/AssetLibrary/ImageLibrary/ImageLibraryDataStore");
var AbstractSystemFolderDataStore_1 = require("Common/AssetLibrary/ImageLibrary/SystemFolderStores/AbstractSystemFolderDataStore");
var AssetFetchingError_1 = __importDefault(require("Common/AssetLibrary/Error/AssetFetchingError"));
var UnsplashDataStore = (function (_super) {
    __extends(UnsplashDataStore, _super);
    function UnsplashDataStore(unsplashImageService, stockImageService) {
        var _this = _super.call(this) || this;
        _this.unsplashImageService = unsplashImageService;
        _this.stockImageService = stockImageService;
        _this.systemFolderId = Types_1.ImageLibrarySystemFolder.Unsplash;
        _this.currentCollections = [];
        _this.collectionsPageCounter = 0;
        _this.unsplashCollectionsPageCounter = 0;
        _this.transformImages = function (imageData) {
            return imageData.map(function (data) { return ({
                id: data.id,
                url: data.urls.regular,
                thumbnailUrl: data.thumbnailUrl,
                altDescription: data.altDescription,
            }); });
        };
        _this.transformStockImages = function (imageData) {
            return imageData.map(function (data) { return ({
                id: data.id,
                url: data.url,
                thumbnailUrl: data.thumbnailUrl,
                altDescription: data.altDescription,
            }); });
        };
        return _this;
    }
    UnsplashDataStore.prototype.searchImages = function (searchTerm_1) {
        return __awaiter(this, arguments, Promise, function (searchTerm, pageNumber) {
            var imageData, error_1;
            if (pageNumber === void 0) { pageNumber = 0; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!searchTerm) {
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.unsplashImageService.searchPhotos({
                                query: searchTerm,
                                page: pageNumber,
                                perPage: ImageLibraryDataStore_1.IMAGES_PER_PAGE,
                            })];
                    case 2:
                        imageData = _a.sent();
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        throw new AssetFetchingError_1.default("Unable to fetch Unsplash images!");
                    case 4:
                        if (imageData.length < ImageLibraryDataStore_1.IMAGES_PER_PAGE) {
                            this.isServiceOutOfNewData = true;
                        }
                        this.currentImages = (0, lodash_1.uniqBy)(__spreadArray(__spreadArray([], __read(this.currentImages), false), __read(this.transformImages(imageData)), false), "id");
                        return [2];
                }
            });
        });
    };
    UnsplashDataStore.prototype.fetchCollections = function () {
        return __awaiter(this, void 0, Promise, function () {
            var targetLength, _loop_1, this_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ++this.collectionsPageCounter;
                        targetLength = this.collectionsPageCounter * ImageLibraryDataStore_1.IMAGES_PER_PAGE;
                        _loop_1 = function () {
                            var collections, error_2;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        ++this_1.unsplashCollectionsPageCounter;
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([1, 3, , 4]);
                                        return [4, this_1.unsplashImageService.listCollections({
                                                page: this_1.unsplashCollectionsPageCounter,
                                                perPage: ImageLibraryDataStore_1.IMAGES_PER_PAGE,
                                            })];
                                    case 2:
                                        collections = _b.sent();
                                        return [3, 4];
                                    case 3:
                                        error_2 = _b.sent();
                                        throw new AssetFetchingError_1.default("Unable to fetch Unsplash collections!");
                                    case 4:
                                        (0, mobx_1.runInAction)(function () {
                                            _this.currentCollections = __spreadArray(__spreadArray([], __read(_this.currentCollections), false), __read(collections), false);
                                        });
                                        return [2];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 1;
                    case 1:
                        if (!(this.currentCollections.length < targetLength)) return [3, 3];
                        return [5, _loop_1()];
                    case 2:
                        _a.sent();
                        return [3, 1];
                    case 3: return [2];
                }
            });
        });
    };
    UnsplashDataStore.prototype.fetchCollectionImages = function (collectionId_1) {
        return __awaiter(this, arguments, Promise, function (collectionId, pageNumber) {
            var imageData, error_3;
            if (pageNumber === void 0) { pageNumber = 0; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.unsplashImageService.getCollectionPhotos(collectionId, {
                                page: pageNumber,
                                perPage: ImageLibraryDataStore_1.IMAGES_PER_PAGE,
                            })];
                    case 1:
                        imageData = _a.sent();
                        return [3, 3];
                    case 2:
                        error_3 = _a.sent();
                        throw new AssetFetchingError_1.default("Unable to fetch Unsplash images!");
                    case 3:
                        if (imageData.length < ImageLibraryDataStore_1.IMAGES_PER_PAGE) {
                            this.isServiceOutOfNewData = true;
                        }
                        this.currentImages = (0, lodash_1.uniqBy)(__spreadArray(__spreadArray([], __read(this.currentImages), false), __read(this.transformImages(imageData)), false), "id");
                        return [2];
                }
            });
        });
    };
    UnsplashDataStore.prototype.fetchQwilrStockImages = function () {
        return __awaiter(this, arguments, Promise, function (pageNumber) {
            var imageData;
            if (pageNumber === void 0) { pageNumber = 0; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.stockImageService.getStockImages(pageNumber, ImageLibraryDataStore_1.IMAGES_PER_PAGE)];
                    case 1:
                        imageData = _a.sent();
                        if (imageData.length < ImageLibraryDataStore_1.IMAGES_PER_PAGE) {
                            this.isServiceOutOfNewData = true;
                        }
                        this.currentImages = (0, lodash_1.uniqBy)(__spreadArray(__spreadArray([], __read(this.currentImages), false), __read(this.transformStockImages(imageData)), false), "id");
                        return [2];
                }
            });
        });
    };
    Object.defineProperty(UnsplashDataStore.prototype, "collections", {
        get: function () {
            return this.currentCollections;
        },
        enumerable: false,
        configurable: true
    });
    UnsplashDataStore.prototype.emptyCollectionList = function () {
        this.currentCollections = [];
        this.collectionsPageCounter = 0;
        this.unsplashCollectionsPageCounter = 0;
        this.isServiceOutOfNewData = false;
    };
    var _a, _b, _c, _d;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Array)
    ], UnsplashDataStore.prototype, "currentCollections", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], UnsplashDataStore.prototype, "searchImages", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], UnsplashDataStore.prototype, "fetchCollections", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], UnsplashDataStore.prototype, "fetchCollectionImages", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], UnsplashDataStore.prototype, "fetchQwilrStockImages", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], UnsplashDataStore.prototype, "collections", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UnsplashDataStore.prototype, "emptyCollectionList", null);
    return UnsplashDataStore;
}(AbstractSystemFolderDataStore_1.AbstractSystemFolderDataStore));
exports.default = UnsplashDataStore;
